import { useQuery, DefinedUseQueryResult } from '@tanstack/react-query'
import { getCoordinates } from '../utils'

// eslint-disable-next-line valid-jsdoc
/**
 * Custom hook to get address and coords data from Google API
 * @param {string} searchAddress
 * @param {import("../../definitions/GoogleMapsApiTypes").GMapsCoords} initial
 * @return {DefinedUseQueryResult<import("../../definitions/GoogleMapsApiTypes").GMapsCoords, unknown>}
 */
const useGoogleLocation = (searchAddress, initial) => {
  return useQuery(['location', searchAddress], () => getCoordinates(searchAddress), {
    initialData: initial,
    enabled: false,
  })
}

export default useGoogleLocation
